
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { vendorSelector } from "slices/vendorSlice";
import Api from "services/api"
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { CustomSwitch } from "components/common/Switch";
import { changeStatus } from "slices/vendorSlice";
import { removeMultipleVendors } from "slices/vendorSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import AddVendor from "components/vendor/AddVendor";
import { fetchVendorsListPage } from "slices/vendorSlice";
import { usePermissions } from "layouts/Admin";

const apiService = new Api();

function VendorList() {
  const dispatch = useDispatch()
  const { checkPermission } = usePermissions();
  const { vendorList: vendors, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(vendorSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}

  });

  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([10])
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });

  React.useEffect(() => {
    dispatch(fetchVendorsListPage())
  }, [])

  const handleAddVendorPopUp = (item) => {
    setAddForm({
      show: true,
      item,
    });
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message,{className:'successToast'})
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchVendorsListPage())
      hideConfirmDialog()
    }
    else {
      toast.error(message,{className:'errorToast'});
    }
  };

  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const handleRemoveItems = () => {
    dispatch(removeMultipleVendors({ ids: selectedItems }, submitCallback))
  }
  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    // setSelectedItems(vendors?.map((vendor) => vendor.id.toString()))
    setSelectedItems(
      vendors
        ?.filter((vendor) => vendor.email === "appts@excelinterpreting.com")
        .map((vendor) => vendor.id.toString())
    )


  }

  const handlePageChange = React.useCallback((page) => {
    setCurrentPage(page);
    dispatch(fetchVendorsListPage(page));
  }, [])

  const handleClose = () => {
    // refAddutton.current.click();
    setAddForm({ show: false })
  };

  const handleSelect = (value) => {
    setSelectedValue(value)

  }


  //#region TABLE HEAD 

  const renderTableHeader = React.useCallback(() => {

    const callBack = (dir, sortBy) => {

      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchVendorsListPage(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }
    return (
      <tr>
        <th className="col-2">
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete Vendor') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>
        <th className="col-3">
          <TableHeaderItem
            title="Vendor Name"
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-3">
          <TableHeaderItem
            title="Email"
            sortBy="email"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-2">
          <TableHeaderItem
            title="Creation Date"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {(checkPermission('Status Vendor') && checkPermission('Edit Vendor')) &&
          <th className="col-2">Status</th>
        }
        {(checkPermission('Status Vendor') && checkPermission('Edit Vendor')) &&
          <th className="col-2">Actions</th>
        }
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

  //#endregion


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return (
      vendors?.map((vendor, index) => (
        <VendorItem vendor={vendor} index={index}
          selectedItems={selectedItems}
          handleChange={handleChange} handleAddPopUp={handleAddVendorPopUp}
          current_page={current_page}
          pageLength={pageLength}
          checkPermission={checkPermission}
        />
      ))
    )
  }, [vendors, selectedItems, current_page]);

  //#endregion


  return (
    <ListLayout
      heading="Vendors"
      time={true}
      title=""
      buttonTitle="Add Vendor"
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      fetchList={fetchVendorsListPage}
      selectedItems={selectedItems}
      addButtonDisabled={!checkPermission('Add Vendor')}
      handleRemoveItems={handleRemoveItems}
      renderAddForm={(callback) => <AddVendor item={addForm.item} show={addForm.show} statusPerm={checkPermission('Status Vendor')}  onClose={handleClose} callback={() => {
        callback();
        refAddutton.current.click();
      }} />}
      refAddutton={refAddutton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddVendorPopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      searchPlaceholder="Search Vendors ..."
      noOfItems={total}
      // addformModal={false}
    >

      {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
    </ListLayout>
  )

}


const VendorItem = ({
  vendor, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState(vendor?.status == "Active" ? 1 : 0 || 0);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));
  }

  React.useEffect(() => {
    setStatus(
      vendor?.status?.toLowerCase() == "active" ? 1 : 0
    )
  }, [vendor])

  const getBackgroundStyle = (status) => {
    return status === 0 ? { background: '#d7d7d7' } : {};
  };

  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength])

  return (
    <tr>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete Vendor') &&
            <label className={ `custom-checkbox checkbox ${vendor.email === "appts@excelinterpreting.com" ? 'd-none' : ''}` }>
              <input type="checkbox" name="select-all" data-value={vendor.id} checked={selectedItems.includes(vendor.id.toString())} onChange={handleChange} />
              <span className="checkmark"></span>
            </label>
          }
        </div>
      </td>
      <td style={getBackgroundStyle(status)}>
        {vendor.name}
      </td>
      <td style={getBackgroundStyle(status)}>
        {vendor.email}
      </td>
      <td style={getBackgroundStyle(status)}>
        {convertTimeToUTC(vendor.created_at)}
      </td>
      <td style={getBackgroundStyle(status)}>
          {checkPermission('Status Vendor') && vendor.id !== 8 && (
            <CustomSwitch handleChange={(status) => handleStatusChange(vendor?.id, status)} checked={status == 1 ? true : false} />
          )}
      </td>
      <td style={getBackgroundStyle(status)}>
        <div className="row_check">
          {checkPermission('Edit Vendor') &&
            <button className="table_edit" data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => { handleAddPopUp({ ...vendor, status }) }} disabled={vendor.email === "appts@excelinterpreting.com"}
            style={vendor.email === "appts@excelinterpreting.com" ? { display: "none" } : {}}>Edit</button>
          }
        </div>
      </td>
    </tr>
  )
}


export default VendorList;
